import React from "react";
import { IconBunningsWarehouse, IconCatch, IconKmart, IconTarget, } from "@catchoftheday/cg-components";
import { MigrationNudgeDivisionsZone } from "../../layouts/MigrationNudgeLayout/MigrationNudgeLayout";
const commonProps = {
    mx: { xs: 1, md: 8 },
    height: "auto",
};
export const Divisions = () => {
    return (<MigrationNudgeDivisionsZone>
      <IconCatch width={{ xs: "54px", md: "77px" }} aria-label="Catch" {...commonProps}/>
      <IconKmart width={{ xs: "47px", md: "67px" }} aria-label="Kmart" {...commonProps}/>
      <IconTarget width={{ xs: "68px", md: "97px" }} aria-label="Target" {...commonProps}/>
      <IconBunningsWarehouse width={{ xs: "69px", md: "99px" }} aria-label="Bunnings Warehouse" {...commonProps}/>
    </MigrationNudgeDivisionsZone>);
};
